import React, { useEffect, useState } from "react";
// import { Container, Row, Col, Form, Dropdown } from "react-bootstrap";

import "./Dashboard.scss";
import Header from "Components/Header/Header";
import Footer from "Components/Footer/Footer";
import AvailableFunds from "Components/AvailableFunds/AvailableFunds";
import DashboardLinks from "Components/DashboardLink/DashboardLinks";
import LoadVipAccount from "Components/LoadVipAccount";
// import useFundType from "Utils/Hooks/useFundType";
// import AvailableFundsNetspend from "Components/AvailableFunds/AvailableFundsNetspend";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";
import useSession from "Utils/Hooks/useSession";
import AppLogout from "Utils/Hooks/AppLogout";
import { FUND_SOURCE_TYPE, PRODUCTTYPES } from "Utils/Constants";
import { FindMatchedFundingSource } from "Utils/Utils";

const Dashboard = () => {
  const { session } = useSession();
  const productType = session?.patronProductType === PRODUCTTYPES.PREFERRED ? 'VIPP' : 'VIPO';
  document.title = productType + " - Dashboard";
  // const fundType = useFundType();
  // const [netspendBalance, setNetspendBalance] = useState(fundType === "netspend" ? window.sessionStorage.getItem("netspendbalance") : null);
  // const formatAccountNumber = (accountNumber) => {
  //   return "x" + accountNumber.replaceAll("*", "");
  // };

  // let netspendFundDetails = [];
  // if (fundType === "netspend") {
  //   if (window.sessionStorage.getItem("selectedFund")) {
  //   }
  //   netspendFundDetails = JSON.parse(
  //     window.sessionStorage.getItem("selectedFundDetails")
  //   );
  // }

  // const [dropdownTitle, setDropdownTitle] = useState(title);
  const vipApi = useVipApiFetcher();
  // const [selectedFund, setSelectedFund] = useState(netspendFundDetails);
  const [fundingSource, setFundingSource] = useState(null); // [selectedFund, setSelectedFund
  // const [fundingSources, setFundingSources] = useState([]);
  // function onBankSelected(bankAccount) {
  //   setDropdownTitle(bankAccount.bankName?.toUpperCase().substring(0, 24) + " " + formatAccountNumber(bankAccount.maskedAccountNumber));
  //   setSelectedFund(bankAccount);
  // }
  // const formattedTitle = fundType === "netspend" ? ((dropdownTitle.indexOf(' *') > 0) ? <><span>{dropdownTitle.slice(0, dropdownTitle.indexOf(' *'))}</span>{dropdownTitle.slice(dropdownTitle.indexOf(' *'))}</> : dropdownTitle) : '';


  useEffect(() => {
    // if (fundType === "netspend") {
    //   vipApi.fetchData("/api/bank/netspend").then((fundList) => {
    //     setFundingSources(fundList);
    //   });
    //   vipApi
    //     .fetchData(`/api/bank/netspend/${selectedFund.maskedAccountNumber}/balance`)
    //     .then((balance) => {
    //       window.sessionStorage.setItem("netspendbalance", balance);
    //       setNetspendBalance(balance);
    //     });
    // }
    if (session?.patronProductType === PRODUCTTYPES.ONLINE) {
      const selectedFundDetails = window.sessionStorage.getItem("selectedFundDetails") ? JSON.parse(window.sessionStorage.getItem("selectedFundDetails")) : null;
      vipApi.fetchData("/api/bank/ach").then((fundList) => {
        const plaidFundList = fundList.filter((fund) => (fund.achOpenType === FUND_SOURCE_TYPE.PLAID.toLocaleLowerCase() || fund.achOpenType === FUND_SOURCE_TYPE.FINICITY) && fund.availableLimit)
        if (plaidFundList.length > 0) {
          if (selectedFundDetails) {
            const selectedFundingSource = FindMatchedFundingSource(fundList, selectedFundDetails);
            setFundingSource(selectedFundingSource);
          }
          else {
            setFundingSource(plaidFundList[0]);
          }
        }
      });
    }
  }, [vipApi.ready]); // [vipApi.ready, selectedFund]);

  return (
    <AppLogout>
      <LoadVipAccount>
        <Header back={false} />
        <AvailableFunds fundingSource={fundingSource} />
        {/* {fundType === 'netspend' ? <AvailableFundsNetspend selectedFund={selectedFund.maskedAccountNumber} availableFunds={netspendBalance} /> : <AvailableFunds fundingSource={fundingSource} />}
        <div className="dashboard">
          <Container>
            {session.transactionSucceeded && fundType === 'netspend' && <Row>
              <Col md={3}></Col>
              <Col md={7}>
                <Form.Group controlId="bankAccount">
                  <Form.Label>FUNDING SOURCE</Form.Label>
                  <Dropdown>
                    <Dropdown.Toggle variant="white" id="dropdown-basic">
                      {formattedTitle}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {fundingSources?.map((bankAccount, index) => {
                        return <Dropdown.Item key={index} onClick={() => { onBankSelected(bankAccount) }}>{bankAccount.bankName?.toUpperCase() + " " + formatAccountNumber(bankAccount.maskedAccountNumber)}</Dropdown.Item>
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
              </Col>
            </Row>}
          </Container>
        </div> */}
        <DashboardLinks />
        <Footer />
      </LoadVipAccount>
    </AppLogout>);
};

export default Dashboard;